<template>
<v-dialog v-model="isVisible" absolute max-width="600" style="height: 90%">
    <v-card>
        <v-container>
            <v-checkbox v-for="item in items" :key="item.id" v-model="item.value" class="mx-2">
                <template v-slot:label>
                    <div style="color: grey"><strong style="color: black">{{ item.title }}</strong>{{ item.description }}</div>
                </template>
            </v-checkbox>
        </v-container>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="white--text" color="deep-purple accent-4" @click="update">확 인</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    name: 'condition-dialog',
    data() {
        return {
            isVisible: false,
            items: [
                {
                    id: 'per',
                    title: 'PER (주가수익비율)',
                    description: '  시가총액 / 당기순이익',
                    value: true
                },
                {
                    id: 'pbr',
                    title: 'PBR (주가순자산비율)',
                    description: '  시가총액 / 순자산',
                    value: false
                },
                {
                    id: 'psr',
                    title: 'PSR (주가매출비율)',
                    description: '  시가총액 /매출',
                    value: false
                },
                {
                    id: 'pcr',
                    title: 'PCR (주가현금흐름비율)',
                    description: '  시가총액 / 영업현금흐름',
                    value: false
                },
                {
                    id: 'ncav',
                    title: 'NCAV Ratio (순유동자산 비율) [%]',
                    description: '  순유동자산 / 시가총액',
                    value: false
                },
                {
                    id: 'roe',
                    title: 'ROE (자기자본이익률) [%]',
                    description: ' 당기순이익 / 순자산',
                    value: false
                },
                {
                    id: 'roa',
                    title: 'ROA (총자산이익률) [%]',
                    description: ' 당기순이익 / 자산총액',
                    value: false
                },
                {
                    id: 'gpa',
                    title: 'GP/A (매출총이익 대비 자산총액 비율) [%]',
                    description: ' 매출총이익 / 자산총액',
                    value: false
                },
                {
                    id: 'op',
                    title: '영업이익률 [%]',
                    description: ' 영업이익 / 매출',
                    value: false
                },
                {
                    id: 'profit',
                    title: '순이익률 [%]',
                    description: ' 당기순이익 / 매출',
                    value: false
                },
                {
                    id: 'debt',
                    title: '부채비율 [%]',
                    description: ' 부채총액 / 자본총액',
                    value: false
                },
                {
                    id: 'total_capital',
                    title: '시가총액 [억]',
                    description: ' 전체 상장주식 평가액',
                    value: false
                },
            ],
        }
    },
    methods: {
        show() {
            this.isVisible = true
        },
        update() {
            this.$emit('update')
            this.isVisible = false
        }
    }
}
</script>
